<template>
  <div id="Dashboard">
    <b-container fluid>
      <b-row>
        <transition name="slide">
          <b-col id="main_nav" sm="12" class="bg-blue" v-if="main_nav_visibility">
            <div class="only-desktop">
              <img class="scale" src="/static/logo.png" style="display:block;transform:scale(0.8)">
            </div>

            <div id="mobile_user_info" class="only-mobile">
              <div class="close" @click="main_nav_visibility=false">
                <font-awesome-icon :icon="['far', 'times-circle']" style="color:white;"/>
              </div>

              <div class="user_pic">
                <img class="scale" src="/static/re.png">
              </div>
              <br>

              <div
                style="display:flex;align-items:center;justify-content: center;flex-direction:column"
              >
                <h3 style="color:white;">{{user_info.full_name}}</h3>
                <div @click="goto('/dashboard/account')">
                  <b-link class="color-green" to="/dashboard/account" style="margin:0 5px">Your Account</b-link>
                </div>
                <b-link class="color-green" @click="logout" style="margin:0 5px">Logout</b-link>
              </div>
            </div>

            <b-container fluid class="nav-main-link collapsible">
              <b-row align-v="center" v-b-toggle.collapse1>
                <b-col class="nav-icon" cols="1">
                  <font-awesome-icon icon="question-circle" style="color:white"/>
                </b-col>
                <b-col class cols="9">
                  <h6 class="collapsible-heading">Doubts</h6>
                </b-col>
                <b-col class="toggler" cols="2">
                  <font-awesome-icon icon="angle-up" style="color:white"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-collapse id="collapse1" class="mt-2">
                    <ul class="collapsible-ul">
                      <li>
                        <div @click="goto('/dashboard/add-doubt')">
                          <b-link to="/dashboard/add-doubt">Add a doubt</b-link>
                        </div>
                      </li>
                      <li>
                        <div @click="goto('/dashboard/solutions')">
                          <b-link to="/dashboard/solutions">Solutions</b-link>
                        </div>
                      </li>
                      <!-- <li><b-link to="/Dashboard/history">History</b-link></li> -->
                    </ul>
                  </b-collapse>
                </b-col>
              </b-row>
            </b-container>
            <!-- queries -->
            <b-container fluid class="nav-main-link collapsible">
              <b-link align-v="center" class="row">
                <b-col class="nav-icon" cols="1">
                  <font-awesome-icon icon="book" style="color:white"/>
                </b-col>
                <b-col class cols="9">
                  <div @click="goto('/dashboard/study-material')">
                    <b-link
                      to="/dashboard/study-material"
                      class="collapsible-heading"
                    >Study Material</b-link>
                  </div>
                  <!-- <b-link to="/dashboard/study-material">Study Material</b-link> -->
                </b-col>
                <b-col class cols="2"></b-col>
              </b-link>
            </b-container>
            <!-- study material -->
            <b-container fluid class="nav-main-link collapsible">
              <b-row align-v="center">
                <b-col class="nav-icon" cols="1">
                  <font-awesome-icon icon="sticky-note" style="color:white"/>
                </b-col>
                <b-col class cols="9">
                  <div @click="goto('/dashboard/notepad')">
                    <b-link to="/dashboard/notepad" class="white-text">Notepad</b-link>
                  </div>
                  <!-- <b-link disabled>Notepad</b-link> -->
                </b-col>
                <b-col></b-col>
              </b-row>
            </b-container>
            <!--notepad -->
            <b-container fluid class="nav-main-link collapsible">
              <b-row align-v="center">
                <b-col class="nav-icon" cols="1">
                  <font-awesome-icon icon="calculator" style="color:white"/>
                </b-col>
                <b-col class cols="9">
                  <div @click="goto('/dashboard/utilities')">
                    <b-link to="/dashboard/utilities" class="white-text">Utilities</b-link>
                  </div>
                </b-col>
                <b-col></b-col>
              </b-row>
            </b-container>
            <!-- utilities -->
            <b-container fluid class="nav-main-link collapsible">
              <b-row align-v="center">
                <b-col class="nav-icon" cols="1">
                  <font-awesome-icon icon="at" style="color:white"/>
                </b-col>
                <b-col cols="9">
                  <div @click="goto('/dashboard/support')">
                    <b-link to="/dashboard/support" class="white-text">Live Support</b-link>
                  </div>
                </b-col>
                <b-col></b-col>
              </b-row>
            </b-container>
            <!-- mailbox -->
            <b-container fluid class="nav-main-link collapsible">
              <b-row align-v="center" v-b-toggle.collapse_packages>
                <b-col class="nav-icon" cols="1">
                  <font-awesome-icon icon="rupee-sign" style="color:white"/>
                </b-col>
                <b-col class cols="9">
                  <h6 class="collapsible-heading">Packages</h6>
                </b-col>
                <b-col class="toggler" cols="2">
                  <font-awesome-icon icon="angle-up" style="color:white"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-collapse id="collapse_packages" class="mt-2">
                    <ul class="collapsible-ul">
                      <li>
                        <div @click="goto('/dashboard/packages')">
                          <b-link to="/dashboard/packages">Add new</b-link>
                        </div>
                      </li>

                      <li>
                        <div @click="goto('/dashboard/packages-history')">
                          <b-link to="/dashboard/packages-history" >History</b-link>
                        </div>
                      </li>
                    </ul>
                  </b-collapse>
                </b-col>
              </b-row>
            </b-container>
            <!-- packages -->
            <b-container fluid class="nav-main-link collapsible">
              <b-row align-v="center">
                <b-col class="nav-icon" cols="1">
                  <font-awesome-icon icon="graduation-cap" style="color:white"/>
                </b-col>
                <b-col class cols="9">
                   <div @click="goto('/dashboard/career-counselling')">
                      <b-link to="/dashboard/career-counselling" class="white-text">Career Counselling</b-link>
                    </div>
                </b-col>
                <b-col></b-col>
              </b-row>
            </b-container>
            <!-- career counselling -->
            <b-container fluid class="nav-main-link collapsible">
              <b-row align-v="center">
                <b-col class="nav-icon" cols="1">
                  <font-awesome-icon icon="share-alt" style="color:white"/>
                </b-col>
                <b-col cols="9">
                  <div @click="goto('/dashboard/share')">
                    <b-link to="/dashboard/career-counselling" class="white-text">Share</b-link>
                  </div>
                </b-col>
                <b-col></b-col>
              </b-row>
            </b-container>
            <!-- share -->
            <!-- <b-container fluid class="nav-main-link collapsible">
              <b-row align-v="center">
                <b-col class="nav-icon" cols="1">
                  <font-awesome-icon icon="star" style="color:white"/>
                </b-col>
                <b-col cols="9">
                  <b-link disabled>Report and Ratings</b-link>
                </b-col>
                <b-col></b-col>
              </b-row>
            </b-container> -->
            <!-- report -->
            
          </b-col>
        </transition>
        <transition name="fade">
          <div id="welcome_tour" v-if="tour_visible">
            <div class="pre-actions">
              <div class="close" @click="toggleTour()">
                <font-awesome-icon :icon="['far', 'times-circle']" style="color:white;"/>
              </div>
            </div>
            <div class="carousel-wrapper" style="margin-top:60px;max-width:800px; margin-left:auto; margin-right:auto;">
              <carousel perPage="1" paginationActiveColor="#77bf43" paginationSize="8">
                <slide>
                  <img src="/static/welcometour/1.jpg" style="height:70vh;width:auto;margin:auto;display:block"/>
                </slide>
                <slide>
                  <img src="/static/welcometour/2.jpg" style="height:70vh;width:auto;margin:auto;display:block" />
                </slide>
                <slide>
                  <img src="/static/welcometour/3.jpg" style="height:70vh;width:auto;margin:auto;display:block"/>
                </slide>
                <slide>
                  <img src="/static/welcometour/4.jpg" style="height:70vh;width:auto;margin:auto;display:block"/>
                </slide>
              </carousel>
            </div>
          </div>
        </transition>
        <b-col id="main_wrapper">
          <div id="top_bar" class="shadow-1" style="display:flex;">
            <!-- <b-row align-v="center" align-h="between">
  						<b-col lg="7">
  						</b-col>
  						<b-col clas="" lg="5">

  							<div id="top_bar_right">
  								<font-awesome-icon :icon="['far', 'bell']" size="2x" />
  							</div>
  						</b-col>
            </b-row>-->
            <font-awesome-icon
              class="icon"
              icon="bars"
              @click="main_nav_visibility= !main_nav_visibility"
              style="padding: 6px;display: block;flex-basis: 13%;align-self: center;height: 100%;max-width:35px;}"
            />

            <b-navbar toggleable="md" style="flex-basis:100%;padding-left:0">
              <b-navbar-nav class>
                <img src="/static/logo.png" style="width:80px;display:block" class="only-mobile">
              </b-navbar-nav>
              <b-navbar-nav class="ml-auto">
                <b-nav-item class="mobile-padding-10">
                  <span style="display:flex" @click="toggleTour()">
                    <font-awesome-icon class="icon" icon="info-circle"/>
                  </span>
                </b-nav-item>

                <b-nav-item class="mobile-padding-10">
                  <b-dropdown variant="link" right class="top_bar_button" size="lg" no-caret>
                    <template slot="button-content">
                      <div class="icon-dropdown">
                        <font-awesome-icon :icon="['far', 'bell']"/>
                      </div>
                    </template>
                    <b-dropdown-item href="#" disabled>You have no notifications!</b-dropdown-item>
                  </b-dropdown>
                </b-nav-item>

                <b-nav-item class="only-desktop">
                  <b-dropdown class variant="link" size="lg" no-caret>
                    <template slot="button-content" class="top_bar_button">
                      <div class="user_pic">
                        <img class="scale" src="/static/re.png">
                      </div>
                    </template>
                    <b-dropdown-item to="/dashboard/account" class="color-green">Your Account</b-dropdown-item>
                    <a @click="logout" class="normalish">Logout</a>
                  </b-dropdown>
                </b-nav-item>
              </b-navbar-nav>
            </b-navbar>
          </div>
          <div id="main_content">
            <router-view></router-view>
            <!-- <a href="data:text/plain;base64,SGVsbG8sIFdvcmxkIQ%3D%3D">A</a> -->
          </div>
          <div id="quick_toolbar">
            <div class="wrapper">
              <div class="item" @click="goto('/dashboard/add-doubt')">
                <b-link class="quick_toolbar_link" to="/dashboard/add-doubt">
                  <font-awesome-icon icon="question-circle"/>
                  <p>New Doubt</p>
                </b-link>
              </div>
              <div class="item" @click="goto('/dashboard/solutions')">
                <b-link class="quick_toolbar_link" to="/dashboard/solutions">
                  <span style="font-size:1rem">✓</span>
                  <p>Solutions</p>
                </b-link>
              </div>
              <div class="item" @click="goto('/dashboard/study-material')">
                <b-link class="quick_toolbar_link" to="/dashboard/study-material">
                  <font-awesome-icon icon="book"/>
                  <p>Study</p>
                </b-link>
              </div>
              <div class="item" @click="goto('/dashboard/notepad')">
                <b-link class="quick_toolbar_link" to="/dashboard/notepad">
                  <font-awesome-icon icon="sticky-note"/>
                  <p>Notepad</p>
                </b-link>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import dropdown from "vue-my-dropdown";
import loader from "../Loader.vue";

export default {
  name: "Dashboard",
  data() {
    return {
      msg: "Welcome to QdsPro",
      visible: false,
      slide_open: false,
      main_nav_visibility: false,
      tour_visible: false
    };
  },
  computed: {
    user_info: function() {
      return this.$store.getters.user;
    }
  },
  components: {
    dropdown,
    loader
  },
  created: async function() {},
  mounted: async function() {
    // keep main_nav open on desktop
    if (window.innerWidth > 1280) {
      this.main_nav_visibility = true;
    }

    var user = this.$store.getters.user;

    if (!user.is_logged_in) {
      this.$router.replace("/login");
    } else {
      var action = await this.$store.dispatch("fetch_me");
      var action2 = this.$store.dispatch("fetch_doubts");
      if (this.user_info.credits.credit != null) {
        var credits =
          parseFloat(this.user_info.credits.credit) -
          parseFloat(this.user_info.credits.debit);
        console.log(credits);
        if (credits <= 0) {
          this.$router.replace("/dashboard/packages");
        } else {
          this.$router.replace("/dashboard/add-doubt");
        }
      } else {
        this.$router.replace("/dashboard/packages");
      }
    }
  },
  methods: {
    async logout() {
      console.log("logging out");
      await this.$store.dispatch("logout");
      this.$toasted.show("Logged out successfully!", { type: "success" });
      this.$router.push("/login");
    },
    open() {
      this.slide_open = true;
    },
    close_main_nav() {
      this.main_nav_visibility = false;
    },
    goto(link) {
      if (window.innerWidth < 1280) this.main_nav_visibility = false;
      this.$router.push(link);
    },
    toggleTour() {
      console.log('here tour');
      console.log(this.tour_visible);
      this.tour_visible = !this.tour_visible;
      console.log(this.tour_visible);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.white-text {
  color: white;
}
#mobile_user_info {
  padding: 20px;
  text-align: center;
}
#mobile_user_info .close {
  position: absolute;
  top: 10px;
  right: 10px;
}

#welcome_tour .close {
  position: absolute;
  top: 10px;
  right: 10px;
}

.only-desktop {
  display: none;
}
.mobile-padding-10 {
  padding: 0 3px;
}
#top_bar {
  /*padding: 10px;*/
  top: 0px;
  position: sticky;
  background-color: #262f3c;
  box-shadow: 0px 1px 15px 1px rgba(69, 65, 78, 0.25);
  z-index: 999;
}

#top_bar .icon {
  color: white;
  font-size: 1.3rem;
  cursor: pointer;
}

#top_bar .icon-dropdown {
  font-size: 1.3rem;
  color: white;
  cursor: pointer;
}

#main_nav {
  height: 100vh;
  overflow: auto;
  padding-left: 10px;
  padding-right: 10px;
}

.nav-main-link .row .col-lg-8 {
  padding-left: 10px;
  padding-right: 10px;
}
.nav-icon {
  padding-left: 7px;
}
.navbar-nav {
  flex-direction: row;
  align-items: center;
}
.user_name {
  text-align: left;
  color: black;
  margin-bottom: 0;
}
.user_info * {
  text-align: left;
  display: block;
}
#main_content {
  /*height: 100vh;*/
  overflow: auto;
  overflow-x: hidden;
}
#the_user_info {
  background-color: whitesmoke;
  /*padding: 5px 0;*/
}

.user_pic img {
  width: 50px;
  border-radius: 50px;
}

.action {
  text-align: right;
  margin-right: 15px;
}

.action > svg {
  margin: 0 17px;
}

#queries {
  padding: 5px 0;
  margin: 5px 0;
}

.nav-main-link {
  padding: 5px 0;
  margin: 2px 0;
}
ul {
  list-style-type: none;
  margin-bottom: 0;
}
li a,
li {
  color: white;
  display: block;
  outline: 0;
}

li a.active {
  color: #77bf43;
}

.collapsible {
  cursor: pointer;
}
.collapsible-ul {
  padding-left: 20px;
}
.collapsible-ul li a {
  padding: 4px 14px;
  transition: ease background-color 0.4s;
  padding-left: 30px;
}
.collapsible-ul li a:hover {
  background-color: #434a53;
}
.collapsible-ul li a.active {
  background-color: #434a53;
  color: white;
  background: url(../../../static/tab-click.png);
  background-size: cover;
}
.collapsible-heading {
  color: white;
  margin-bottom: 0;
}
.nav-main-link a {
  padding: 10px 0;
}
.nav-main-link .row:focus {
  /*background:url(../../../static/tab-click.png);*/
  /*background-size:cover;*/
  color: white !important;
}
.collapsed .toggler {
  transform: rotate(180deg);
}

.color-green {
  color: #77bf43 !important;
}

#quick_toolbar {
  display: none;
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: white;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  z-index: 99;
}

#quick_toolbar .wrapper {
  display: flex;
}

#quick_toolbar .wrapper .item {
  flex-basis: 0;
  flex-grow: 1;
  padding: 10px;
  text-align: center;
  border-right: 1px solid rgba(0, 0, 0, 0.19);
}

.quick_toolbar_link {
  color:#77bf43 !important;
}

#quick_toolbar .wrapper .item:last-of-type {
  border-right: none;
}

#quick_toolbar .wrapper .item p {
  font-size: 0.7rem;
  color: black;
  margin: 0;
  text-align: center;
}

.toggler {
  transition: ease-in-out transform 0.4s;
  padding: 0;
  text-align: center;
}

#welcome_tour {
  width: 100%;
  position: fixed;
  left:0;
  height:100%;
  background-color: rgba(0, 0, 0, 0.96);
  z-index: 999999;
}

@media screen and (min-width: 768px) {
  #top_bar .navbar-expand-md .navbar-nav {
    align-items: center;
  }
}

@media screen and (min-width: 1280px) {
  .only-mobile {
    display: none !important;
  }
  .only-desktop {
    display: block;
  }
  .hide-on-desktop {
    display: none;
  }
  #main_wrapper {
    height: 100vh;
    overflow: auto;
  }
  #main_nav {
    flex-basis: 22%;
  }
  .normalish {
    margin-left: 25px;
    color: black;
  }
}

@media screen and (max-width: 720px) {
  #main_nav {
    display: block;
    position: fixed;
    top: 0;
    width: 100%;
    left: 0;
    overflow: auto;
    z-index: 9999999999;
  }

  #main_wrapper {
    background-color: #efefef;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  #quick_toolbar {
    display: block;
  }

  #main_content {
    margin-bottom: 60px;
  }
}
.slide-enter-active, .slide-leave-active {
  transition: ease all .5s;
}
.slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform:translateX(-100%);
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Dashboard.vue